import { BtmReturnInspectionProduct, BtmReturnInspectionStatus } from "../model/btm-return-inspection-product";
import { TableCell, TableRow } from "@mui/material";
import React, { Fragment, useState } from "react";
import { AddTask, Cancel, TaskAlt } from "@mui/icons-material";
import { BtmReturnInspectionButton } from "../btm-request-details/btm-return-inspection-button";
import { BtmFailedInspectionDialog } from "../btm-failed-inspection-dialog/btm-failed-inspection-dialog";
import { IUploadedFileDto } from "../../../../common/model/file-exchange-dto";

export const BtmRequestReportedProductsInspection = (
    { data, onChange }: {
        data: BtmReturnInspectionProduct,
        onChange: (status: BtmReturnInspectionStatus, comment?: string, files?: IUploadedFileDto[]) => void,
    }) => {
    const [isFailedInspectionDialogOpen, setIsFailedInspectionDialogOpen] = useState(false);
    const [failedInspectionDialogStatus, setFailedInspectionDialogStatus] = useState<BtmReturnInspectionStatus>(BtmReturnInspectionStatus.None);

    const handleInspectionDetailsDialogOpen = (status: BtmReturnInspectionStatus) => {
        setIsFailedInspectionDialogOpen(true);
        setFailedInspectionDialogStatus(status);
    };

    const handleFailedInspectionComplete = (comment: string, files: IUploadedFileDto[]) => {
        onChange(failedInspectionDialogStatus, comment, files);
        setIsFailedInspectionDialogOpen(false);
    };

    return <Fragment>
        {isFailedInspectionDialogOpen &&
            <BtmFailedInspectionDialog data={data} status={failedInspectionDialogStatus}
                                       onComplete={handleFailedInspectionComplete}
                                       onClose={() => setIsFailedInspectionDialogOpen(false)} />}
        <TableRow>
            <TableCell>{data.productName}</TableCell>
            <TableCell>{data.declarationProductId}</TableCell>
            <TableCell>X 1</TableCell>
            <TableCell>
                <BtmReturnInspectionButton color={"success"} isSelected={data.status === BtmReturnInspectionStatus.Accepted}
                                           onClick={() => onChange(BtmReturnInspectionStatus.Accepted)}>
                    <TaskAlt />
                </BtmReturnInspectionButton>
                <BtmReturnInspectionButton color={"warning"}
                                           isSelected={data.status === BtmReturnInspectionStatus.ConditionallyAccepted}
                                           onClick={() => handleInspectionDetailsDialogOpen(BtmReturnInspectionStatus.ConditionallyAccepted)}>
                    <AddTask />
                </BtmReturnInspectionButton>
                <BtmReturnInspectionButton color={"error"}
                                           isSelected={data.status === BtmReturnInspectionStatus.Refused}
                                           onClick={() => handleInspectionDetailsDialogOpen(BtmReturnInspectionStatus.Refused)}>
                    <Cancel />
                </BtmReturnInspectionButton>
            </TableCell>
        </TableRow>
    </Fragment>;
};
